module.exports = __webpack_public_path__ + "img/04.99c40392.png";